module.exports = __webpack_public_path__ + "static/media/trophy.9be552ab.svg";